import { Component, OnInit, OnDestroy, AfterViewInit, Input } from '@angular/core';
import { TabComponent } from '../tab/tab.component';

@Component({
    selector: 'app-tabs',
    templateUrl: './tabs.component.html',
    styleUrls: ['./tabs.component.scss'],
    standalone: false
})
export class TabsComponent implements OnInit, OnDestroy, AfterViewInit {
  public tabs: TabComponent[];

  @Input('tabContainerWidth')
  public tabContainerWidth: string = '100%';

  @Input('isOverviewTabsComponent')
  public isOverviewTabsComponent: boolean = false;

  @Input('hasHeaderItems')
  public hasHeaderItems: boolean = false;

  @Input('requiresProgrammaticallyChange')
  public requiresProgrammaticallyChange: boolean = false;

  constructor() {
    this.tabs = [];
  }

  public ngOnInit(): void {
  }

  public ngOnDestroy(): void {
  }

  public ngAfterViewInit(): void {

  }

  public addTab(tab: TabComponent) {
    this.tabs.push(tab);

    const activeTabs = this.tabs.filter((tab) => tab.isActive);

    if (activeTabs.length === 0 && this.tabs.length > 0) {
      this.tabs[0].isActive = true;
      if(tab.tabContext !== undefined){
        this.tabs[0].tabClicked.emit(tab.tabContext);
      }
    }
  }

  public tabClicked(tab: TabComponent) {
    if (this.requiresProgrammaticallyChange) {
      if(tab.tabContext !== undefined){
        tab.tabClicked.emit(tab.tabContext);
      }
    } else {
      this.activateTab(tab);
    }
  }

  activateTab(tab: TabComponent) {
    this.tabs.forEach(tab => tab.isActive = false);
    tab.isActive = true;
    if(tab.tabContext !== undefined){
      tab.tabClicked.emit(tab.tabContext);
    }
  }

  public activateTabByContext(context: string) {
    let tab = this.tabs.find(t=>t.tabContext === context);
    if(tab){
      this.activateTab(tab);
    }
  }

  public activateTabByContextProgrammatically(context: string) {
    this.tabs.forEach(tab => tab.isActive = false);
    let tab = this.tabs.find(t=>t.tabContext === context);
    tab.isActive = true;
  }

  public getContextOfCurrentActiveTab() {
    return this.tabs.find(tab => tab.isActive).tabContext;
  }
}
